<!--
 * @Description: 电子围栏修改界面
 * @Author: huzhibo
 * @Email: hzbfun@gmail.com
 * @Date: 2020/7/28 17:03
 -->
<template>
  <add-or-update pageType="update" />
</template>

<script>
// components
import addOrUpdate from "./components/addOrUpdate";

export default {
  name: "customerUpdate",
  components: { addOrUpdate }
};
</script>
